<template>
    <div class="services-landing">
        <!-- <LoadingIndicator v-if="loading"/> -->

        <div class="services-landing--mobile">
            <form @submit.prevent="searchServices">
                <div class="services-landing__input-wrapper">
                    <input type="text" placeholder="Enter keyword" name="query" v-model="filters.query" />
                    <button title="Search" type="submit">
                        <i class="icon-search"></i>
                    </button>
                </div>
            </form>

            <!-- Filters -->
            <div class="services-landing__filters" v-show="!showAlpha">
                <div class="services-landing__filter-button" :class="{
                    'services-landing__filter-button--active':
                        category.title === activeCategoryMobile.title,
                }" v-for="category in servicesMobile.categories" :key="category.title"
                    @click="setActiveCategoryMobile(category)">
                    {{ category.title }}
                </div>
            </div>

            <div class="services-landing__accordian" v-if="!loading && activeCategoryMobile">
                <ServicesFirstLevel :showAlpha="showAlpha"
                    :items="showAlpha ? allServices : activeCategoryMobile.services" />
            </div>

            <LoadingIndicator v-if="loading" />

            <div class="container" v-if="activeCategoryMobile && activeCategoryMobile.services.length === 0
                ">
                <div class="services-landing__empty">
                    Your search did not return any results
                </div>
            </div>
        </div>

        <div class="services-landing__alpha-dropdown--wrapper">
            <div class="services-landing__alpha-dropdown">
                <select id="service_alpha" name="service_alpha" @change="activeAlphaChangeMobile">
                    <option value="" selected>
                        A-Z
                    </option>
                    <option v-for="alpha in alphabet" :key="alpha" :value="alpha">
                        {{ alpha }}
                    </option>
                </select>
                <i class="icon-chevron-down"></i>
            </div>
        </div>

        <div class="services-landing--desktop">
            <div class="page-subnavigation">
                <div class="page-subnavigation__container">
                    <div class="page-subnavigation__items-wrapper">
                        <div class="page-subnavigation__items" v-show="!showAlpha">
                            <a v-for="(category, index) in services.categories" :key="index"
                                @click="setActiveCategory(category, index)" :class="{
                                    active:
                                        activeCategory && activeCategory.title === category.title,
                                }" class="page-subnavigation__item">{{ category.title }}</a>
                        </div>
                        <div class="page-subnavigation__gradient-overlay"></div>
                    </div>
                    <div class="page-subnavigation__actions">
                        <div class="services__filters">
                            <div class="services__alpha-toggle" :class="{
                                'services__alpha-toggle--active': showAlpha,
                            }" @click="toggleAlpha">
                                A-Z
                            </div>
                            <div class="services__search">
                                <form @submit.prevent="searchServices">
                                    <div class="services__input-wrapper">
                                        <input type="text" placeholder="Enter keyword" name="query"
                                            v-model="filters.query" />
                                        <button title="Search" type="submit">
                                            <i class="icon-search"></i>
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="!loading && services.categories && services.categories.length === 0
                ">
                <div class="services-landing__empty">
                    Your search did not return any results
                </div>
            </div>

            <div v-if="activeCategory && !showAlpha"
                :class="`services-landing__accordian services-landing__accordian--${activeCategory.title.toLowerCase()}`">
                <ServicesFirstLevelDesktop :loading="loading" :showNavigation="showNav" :items="activeCategory.services" />
            </div>
            <div class="services-landing__accordian" v-if="showAlpha">
                <ServicesFirstLevelDesktop :loading="loading" :showNavigation="false" :items="allServices" />
            </div>

            <Transition>
                <div class="services__overview spacing-bottom--large" v-if="!loading && overview">
                    <div class="container">
                        <div class="breadcrumbs">
                            <ul>
                                <li v-for="(crumb, index) in overview.breadcrumbs" :key="crumb.url">
                                    <a v-if="overview.breadcrumbs[index - 1]?.name === 'Regions'"
                                        :href="'/services?category=regions&subcategory=' + overview.breadcrumbs[2]?.name">{{
                                            crumb.name }}</a>
                                    <a v-else-if="crumb.name === 'Industries'" :href="'/services?category=industries'">{{
                                        crumb.name }}</a>
                                    <a v-else :href="crumb.url">{{ crumb.name }}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="container">
                        <div class="services__overview-details">
                            <div class="services__section-header">
                                <div class="services__section-title">Overview</div>
                            </div>
                            <div class="services__overview-title" v-html="overview.introText"></div>
                            <a :href="overview.url" class="button button--inline">Go to Full Page</a>
                        </div>
                        <div class="services__overview-contacts"
                            v-if="overview.keyContacts && overview.keyContacts.length > 0">
                            <div class="page-contacts page-contacts--no-padding">
                                <div class="page-contacts__heading">Key Contacts</div>
                                <div class="page-contacts__content">
                                    <div class="page-contact" v-for="(contact, contactindex) in overview.keyContacts"
                                        :key="contactindex">
                                        <div class="page-contact__avatar"
                                            :style="`background-image: url('${contact.profileImage}');`"></div>
                                        <div class="page-contact__info">
                                            <a class="page-contact__name" :href="contact.url"
                                                v-if="!contact.isKeyContact">{{ contact.displayName }}</a>
                                            <div class="page-contact__name" v-if="contact.isKeyContact">
                                                {{ contact.displayName }}
                                            </div>
                                            <div class="page-contact__location">
                                                {{ contact.title }}
                                            </div>
                                            <div class="page-contact__actions">
                                                <div class="page-contact__phone">
                                                    <a :href="`tel:` + contact.directPhone">D: {{ contact.directPhone }}</a>
                                                </div>
                                                <div class="page-contact__socials">
                                                    <a class="page-contact__icon mailto-link" title="Email"
                                                        :data-email="'mailto:' + contact.officeEmail"
                                                        v-on:click.prevent="showMailtoDisclaimer($event)" href="#">
                                                        <i style="pointer-events: none" class="icon-envelope"></i>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Transition>

            <LoadingIndicator v-if="loading" />
        </div>
    </div>
</template>

<script>
import ServicesService from "../../services/services";
import ServicesFirstLevel from "./ServicesFirstLevel.vue";
import ServicesFirstLevelDesktop from "./ServicesFirstLevelDesktop.vue";
import ServicesAlphaDesktop from "./ServicesAlphaDesktop.vue";
import LoadingIndicator from "../../components/Global/LoadingIndicator.vue";
import { store } from "../../store.js";

export default {
    props: ["title"],
    components: {
        ServicesFirstLevel,
        LoadingIndicator,
        ServicesFirstLevelDesktop,
        ServicesAlphaDesktop,
    },
    data() {
        return {
            error: false,
            loading: true,
            allServices: [],
            services: [],
            servicesMobile: [],
            activeCategoryIndex: 0,
            activeCategory: null,
            activeCategoryMobile: null,
            filters: { query: "" },
            hasSearched: false,
        };
    },
    mounted() {
        this.getServices();
    },
    computed: {
        alphabet: function () {
            const alpha = Array.from(Array(26)).map((e, i) => i + 65);
            const alphabet = alpha.map((x) => String.fromCharCode(x));
            return alphabet;
        },
        showNav: function () {
            return (
                !this.hasSearched &&
                this.activeCategory &&
                ["Practices", "Regions"].includes(this.activeCategory.title)
            );
        },
        overview: function () {
            return store.serviceOverview;
        },
        showAlpha: function () {
            return store.serviceShowAlpha;
        },
        activeAlpha: function () {
            return store.serviceActiveAlpha;
        },
    },
    watch: {},
    methods: {
        showMailtoDisclaimer: function (e) {
            window.showMailtoDisclaimer(e);
        },
        toggleAlpha: function () {
            store.serviceShowAlpha = !store.serviceShowAlpha;
            if (store.serviceShowAlpha) {
                store.serviceActiveAlpha = null;
                this.getAlphaServices();
            } else {
                this.getServices();
            }
        },
        setActiveCategory: async function (category, index) {
            this.activeCategory = category;
            this.activeCategoryIndex = index;
        },
        setActiveCategoryMobile: async function (category) {
            this.activeCategoryMobile = category;
        },
        activeAlphaChangeMobile: function (alpha) {
            if (alpha.target.value !== "") {
                store.serviceShowAlpha = true;
                store.serviceActiveAlpha = alpha.target.value;
                this.$nextTick(() => {
                    this.getAlphaServices();
                });
            } else {
                store.serviceShowAlpha = false;
                store.serviceActiveAlpha = null;
                this.getServices();
            }
        },
        setOverview: async function (overview) {
            this.overview = overview;
        },
        getServices: async function () {
            this.loading = true;
            try {
                const services = await ServicesService.services();
                this.services = services;
                this.servicesMobile = services;
                this.activeCategory = services.categories[0];
                this.activeCategoryMobile = services.categories[0];
                const searchParams = new URLSearchParams(window.location.search);
                if (searchParams.has('category')) {
                    services.categories.forEach((cat, index) => {
                        if (cat.title.toLowerCase() === searchParams.get('category')) {
                            this.setActiveCategory(cat, index)
                            this.setActiveCategoryMobile(cat)
                        }
                    })
                }
                this.loading = false;
            } catch (error) {
                console.log(error)
                this.error = true;
            }
        },
        getAlphaServices: async function () {
            this.loading = true;
            try {
                const services = await ServicesService.alphaServices(
                    store.serviceActiveAlpha
                );
                this.allServices = services;
                this.loading = false;
            } catch (error) {
                this.error = true;
            }
        },
        searchServices: async function () {
            this.loading = true;
            this.services = [];
            store.serviceOverview = null;
            this.hasSearched = true;
            this.loading = true;
            try {
                const services = await ServicesService.search(this.filters.query);
                this.services = services;
                this.servicesMobile = services;
                this.activeCategory = services.categories[0];
                this.activeCategoryMobile = services.categories[0];
                this.loading = false;
            } catch (error) {
                this.error = true;
            }
        },
    },
};
</script>

<style scoped>
.v-enter-active,
.v-leave-active {
    transition: opacity 300ms ease-in-out;
}

.v-enter-from,
.v-leave-to {
    opacity: 0;
}
</style>
